import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
    fetchEvaluators(_, queryParams) {
        return axios.get(`${serverUrl}/assessment/evaluators/${queryParams}`)
    },
    manageEvaluator(_, queryParams) {
        return axios.post(`${serverUrl}/assessment/evaluators/manageEvaluator/`, queryParams)
    },
    managePermissionsEvaluator(_, queryParams) {
        return axios.post(`${serverUrl}/assessment/evaluators/managePermissionsEvaluator/`, queryParams)
    },
    getPermissionsEvaluator(_, queryParams) {
        return axios.get(`${serverUrl}/assessment/evaluators/getPermissionsEvaluator/${queryParams}`)
    },
    deletePermissionsEvaluator(_, queryParams) {
        return axios.post(`${serverUrl}/assessment/evaluators/deletePermissionsEvaluator/`,queryParams)
    },
}